import 'globals';

(function ($, window, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        $('[data-toggle="tooltip"]').tooltip();
    });
})(jQuery, window, window.PageLoadedQueue);
